import './App.css';
import { useState, useEffect } from 'react';
import futura from './assets/futura.png'
import Header from './Header'
import CardServizi from './CardServizi'
import CardPartner from './CardPartner'
import Faq from './Faq';
import Footer from './Footer';
import Select from 'react-select'
import { useHistory, useLocation } from "react-router-dom";
import { Modal } from '@nextui-org/react';

function Home() {
	const history = useHistory();
	const [sel, setSel] = useState()
	const [professioni, setProfessioni] = useState([])
	const [prof, setProf] = useState(1)
	const [city, setCity] = useState([])
	const [sel2, setSel2] = useState()
	const [qr, setQr] = useState(false)

	const location = useLocation();



	useEffect(() => {
		if (location?.search?.startsWith('?qr')) {
			setQr(true)
		}
	}, [location]);

	const getProf = () => {
		fetch(`${document.apiURL}/prof`, {
			method: 'GET',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json'
			},
		})
			.then(response => response.json())
			.then(response => {
				setProfessioni(response.map(r => { return { "value": r.id, "label": r.prof_label } }))

			});
	}

	const createBooking = () => {
		history.push(`/booking/${sel !== undefined ? sel : 0}`)

		localStorage.setItem('city', sel2);
	}

	const getCity = () => {
		fetch(document.apiURL + '/city', {
			method: 'GET',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json'
			},
		})
			.then(response => response.json())
			.then(response => {
				setCity(response.map(r => { return { "value": r.id, "label": r.city } }))
			});
	}

	useEffect(() => {
		getProf();
		getCity();
	}, []);

	const [visible, setVisible] = useState(false);
	const handler = () => setVisible(true);
	const closeHandler = () => {
		setVisible(false);

	};

	return (

		<>
			<Header />
			<div className="main-header">
				<div className="container">
					<div className="flex">
						<div className="f1">
							<div className="flex row center-con">
								<h1 className="extra c">Mi prendo cura di te ovunque tu sia.</h1><img src={futura} className="none-web fut">

								</img>
							</div>
							<div className="col sm-mid">
								<h2>Cerchi un professionista o servizio?</h2></div>
							<div className="col sm-mid m-p">


								<Select noOptionsMessage={() => 'Professionista non presente. Contattaci.'} className="react-input" onChange={(e) => setSel(e.value)} placeholder={"Seleziona un professionista"} options={professioni} />
								<Select noOptionsMessage={() => 'Città non presente. Contattaci.'} className="react-input" /*onChange={(e) => setSEL(e.value)}*/ onChange={(e) => setSel2(e.value)} placeholder={"Seleziona una città"} options={city} />

								<button onClick={() => createBooking(prof)} className="button margin-top-min">Vai alla prenotazione</button>
								<div className="mid">
									<p className="margin-top-min">Altrimenti</p></div>
								<button onClick={handler} className="button margin-top-min">Videochiamami</button>
								<div className="mid">

									<p className="margin-top-min">Oppure chiamami al numero</p>
									<a href='tel:+3908119312726'>081 193 12 726</a></div>

							</div>
						</div>
						<img src={futura} alt="" className="none-sma fut" />
					</div>
				</div>
			</div>

			<div className="main-header main-headers">
				<div className="container containers colonna flex-cp servizi">
					<div className="text-center m-p">
						<h2 align="center">Servizi offerti</h2>
						<span className="blue-line">

						</span>
						<p align="center" className="margin-top-min margin">Garantiamo: Centrale operativa attiva dalle 09:00 alle 17:00, Assistenza alla persona Domiciliare, Assistenza Domiciliare Infermieristica </p></div>
					<div className="flex row between scrolling-wrapper-flexbox">
						<CardServizi />
					</div>
				</div>
			</div>
			<div className="main-header main-headers">
				<div className="con-min container containers colonna flex-cp servizi">
					<div className="text-center m-p">
						<h2 align="center">I nostri partner</h2>
						<span className="blue-line">

						</span>
						<p align="center" className="margin-top-min margin">Dotati di strutture sanitarie grazie alle quali riusciamo a garantirti un concreto supporto.</p></div>
					<div className="flex row between scrolling-wrapper-flexbox">

						<CardPartner />
					</div>
				</div>
			</div>


			<div className="con-min containers colonna flex-cp servizi">
				<div className="text-center">
					<h2 align="center">Domande frequenti</h2>
					<span className="blue-line">
					</span>
				</div>
				<div className="flex colonna">
					<Faq filter={"Home"} />
				</div>
			</div>
			<Footer />
			<Modal
				closeButton
				aria-labelledby="modal-title"
				open={visible}
				onClose={closeHandler}
			>
				<div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '2%' }}>
					<img alt="" style={{ padding: '2%' }} src={futura} className="fut" />
					<h4 style={{ padding: '2%' }}>Il servizio partirà a breve. Torna a trovarci!</h4></div>
			</Modal>
			<Modal
				closeButton
				aria-labelledby="modal-title"
				open={qr}
				onClose={() => setQr(false)}
			>
				<div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '2%' }}>
					<img alt="" style={{ padding: '2%' }} src={futura} className="fut" />
					<h4>Ciao!</h4>
					<div style={{padding: '2%'}}>
						<p style={{ textAlign: 'justify', paddingTop: '2%' }}>Il codice che hai scansionato è riservato agli operatori della struttura sanitaria.</p>
						<p style={{ textAlign: 'justify', paddingTop: '2%' }}>Se sei un <strong>operatore sanitario</strong>, ricordati di utilizzare l'app dedicata <i>"FuturaCare Operatori"</i>.</p>
						<p style={{ textAlign: 'justify', paddingTop: '2%' }}>Se sei un <strong>assistito</strong>, o un caregiver di un assistito, puoi scoprire di più su questo ed altri servizi sul <a href="http://www.futura4me.com">nostro sito</a>.</p>
					</div>
				</div>
			</Modal>
		</>

	);
}

export default Home;
